import { parse } from 'json-in-order'

export const parseSearchString = (queryString: string) => {
  const parsed = parse(queryString)
  // @ts-ignore
  return Object.fromEntries(parsed)
}
